import React, { createContext, useState } from "react";

export const DropdownContext = createContext({
    openId: null,
    setOpenId: () => { },
});

export const DropdownProvider = ({ children }) => {
    const [openId, setOpenId] = useState(null);

    return (
        <DropdownContext.Provider value={{ openId, setOpenId }}>
            {children}
        </DropdownContext.Provider>
    );
};
